
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { JobDeliverableComponent } from './job-deliverables.component';
import { MessageModule } from '../message/message.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from '../alert/alert.module';

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AlertModule
  ],
  exports: [JobDeliverableComponent],
  declarations: [JobDeliverableComponent],
  providers: []
})
export class JobDeliverableModule { }
